<template>
  <el-dialog :title="form.id?'编辑':'新建'" :visible.sync="formVisible" width="600px" :close-on-click-modal="false">
    <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="100px">
      <el-form-item label="表情名称" prop="emoName">
        <el-input v-model="form.emoName" placeholder="请输入表情名称" />
      </el-form-item>
      <el-form-item label="图片" prop="imgUrl">
        <imageUpload v-model="form.imgUrl" width="32" height="32" />
      </el-form-item>
      <el-form-item label="排序" prop="sort">
        <el-input v-model="form.sort" placeholder="请输入排序" />
      </el-form-item>
      <el-form-item label="状态：" prop="emoStatus">
        <el-switch v-model="form.emoStatus" :active-value="1" :inactive-value="0"></el-switch>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">取消</el-button>
      <el-button type="primary" @click="doCreate()">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import ImageUpload from "@/components/ImageUpload";
import liveManageApi from '@/api/live/liveManage'
function initFormBean() {
  const formBean = {
    emoName: null,
    emoStatus: 1,
    id: null,
    imgUrl: null,
    sort: null
  }
  return formBean
}

export default {
  components: { ImageUpload },
  data() {
    return {
      form: initFormBean(),
      formVisible: false,
      formRules: {
        emoName: [{ required: true, message: '请输入表情名称', trigger: 'blur' }],
        emoStatus: [{ required: true, message: '请选择状态', trigger: 'change' }],
        imgUrl: [{ required: true, message: '请上传图片', trigger: 'change' }],
        sort: [{ required: true, message: '请输入排序', trigger: 'blur' }]
      },
      isRepSub: false
    }
  },
  created() {
  },
  methods: {
    /**
     * 重置表单
     */
    resetForm() {
      this.form = initFormBean()
    },
    /**
     * 打开新建表单
     */
    handleCreate() {
      this.resetForm()
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    handleUpdate(row) {
      this.resetForm()
      this.form = { ...row }
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    /**
     * 执行新建操作
     */
    doCreate() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          if (this.isRepSub) return
          this.isRepSub = true
          let params = JSON.parse(JSON.stringify(this.form))
          params.sort = +params.sort || 0
          liveManageApi.createEmo(params).then((data) => {
            this.postCallback(data)
          }).catch(res => {
            this.isRepSub = false
          });
        }
      });
    },
    postCallback(response) {
      this.isRepSub = false
      this.$message.success('操作成功')
      this.formVisible = false;
      this.$emit('created')
    },
  }
}
</script>
<style lang="scss" scoped>
.el-select {
  width: 100%;
}
</style>
